import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import {
  B2B_COPILOT_PLAN_AI_LOG_STEPS_AFTER_WRITE,
} from './b2bCopilotPlanDemoContent.part03.js'
import {
  B2B_COPILOT_PLAN_AI_LOG_STEPS_INITIAL,
  B2B_COPILOT_PLAN_BEFORE_WRITE_MARKDOWN,
  B2B_COPILOT_PLAN_INTRO_MARKDOWN,
} from './b2bCopilotPlanDemoContent.part02.js'
import {
  B2B_COPILOT_PLAN_KEY_DESIGN_CLOSING,
  B2B_COPILOT_PLAN_KEY_DESIGN_ITEMS,
  B2B_COPILOT_PLAN_PHASE_TABLE_DATA,
  B2B_COPILOT_PLAN_SUMMARY_BODY,
  B2B_COPILOT_PLAN_SUMMARY_INTRO,
} from './b2bCopilotPlanDemoContent.part04.js'

export function buildB2bCopilotPlanFinalBlocks(
  planArtifactId,
  zipArtifactId = 'artifact-demo-b2b-copilot-plan-zip',
) {
  return [
    { type: 'markdown', content: B2B_COPILOT_PLAN_INTRO_MARKDOWN },
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(B2B_COPILOT_PLAN_AI_LOG_STEPS_INITIAL),
    },
    { type: 'markdown', content: B2B_COPILOT_PLAN_BEFORE_WRITE_MARKDOWN },
    buildSelectionSwitchBlock('agent', 'Research', 'Financial Analysis'),
    {
      type: 'aiResponseLog',
      status: 'ok',
      showLogStatus: false,
      steps: buildWorkflowTimeline(B2B_COPILOT_PLAN_AI_LOG_STEPS_AFTER_WRITE),
    },
    {
      type: 'fileArtifact',
      fileName: 'B2B Copilot — Development Plan.md',
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: planArtifactId,
    },
    {
      type: 'fileArtifact',
      fileName: 'B2B Copilot.zip',
      description: 'Zip archive',
      artifactKind: 'doc',
      artifactId: zipArtifactId,
    },
    { type: 'markdown', content: B2B_COPILOT_PLAN_SUMMARY_INTRO },
    { type: 'heading', level: 3, content: 'Plan at a Glance' },
    { type: 'markdown', content: B2B_COPILOT_PLAN_SUMMARY_BODY },
    { type: 'heading', level: 4, content: 'The Phases' },
    { type: 'table', data: B2B_COPILOT_PLAN_PHASE_TABLE_DATA },
    { type: 'heading', level: 3, content: 'Key Design Calls Baked In' },
    { type: 'list', items: B2B_COPILOT_PLAN_KEY_DESIGN_ITEMS },
    { type: 'markdown', content: B2B_COPILOT_PLAN_KEY_DESIGN_CLOSING, variant: 'muted' },
  ]
}
